import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EnquirySuccess() {
  const [sp] = useSearchParams();
  return (
    <div className="container-x py-20 text-center max-w-2xl mx-auto">
      <CheckCircle2 className="w-20 h-20 text-emerald-500 mx-auto"/>
      <h1 className="font-heading font-extrabold text-3xl mt-4">Enquiry Submitted</h1>
      <p className="text-slate-600 mt-2">Thank you. Your enquiry has been recorded. Our team will contact you shortly.</p>
      <div className="mt-4 inline-block bg-[#FFF7ED] border border-[#EA580C]/30 rounded-md px-4 py-2 font-mono text-[#EA580C] font-bold">{sp.get("id")}</div>
      <div className="mt-6"><Link to="/products"><Button className="btn-orange">Continue Browsing</Button></Link></div>
    </div>
  );
}
